module.exports = __webpack_public_path__ + "site/img/12.47759323.jpg";